import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { BorderedPaper } from 'modules/common/components/BorderedPaper';
import { PoolTable } from 'modules/delegateStaking/components/PoolTable';
import { useTranslation } from 'modules/i18n';
import {
  EMPTY_POOL_ADDRESSES,
  useGetPoolAddressesQuery,
} from 'modules/pool/actions/getPoolAddresses';
import { useGetPoolsQuery } from 'modules/pool/actions/getPools';

import { translation } from './translation';
import { useStyles } from './useStyles';

export function StakingPools(): ReactElement | null {
  const { classes } = useStyles();
  const { t, keys } = useTranslation(translation);
  const { cacheTime } = useConnection();
  const { data: addresses = EMPTY_POOL_ADDRESSES } = useGetPoolAddressesQuery(
    undefined,
    { refetchOnMountOrArgChange: cacheTime },
  );

  const { data: pools } = useGetPoolsQuery(
    { addresses },
    { refetchOnMountOrArgChange: cacheTime },
  );

  if (!pools?.length) {
    return null;
  }

  return (
    <BorderedPaper className={classes.root}>
      <div className={classes.content}>
        <Typography className={classes.title} component="h2" variant="h5">
          {t(keys.title)}
        </Typography>

        <PoolTable poolAddresses={addresses} />
      </div>
    </BorderedPaper>
  );
}
